import * as Yup from "yup";

const RoleSchema = Yup.object().shape({
  role_name: Yup.string().required("Role name is required"),
  role_scale: Yup.string().required("Role scale is required"),
});

export default RoleSchema;
